// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mds-button-container__cwp{align-items:center;display:flex;justify-content:flex-start}.mds-button-container__cwp .mds-button__cwp+.mds-button__cwp{margin-left:8px}.mds-button-container__cwp .mds-button__cwp+.mds-button__cwp.mds-button--small__cwp{margin-left:6px}.mds-button-container__cwp .mds-button--icon-only__cwp+.mds-button__cwp,.mds-button-container__cwp .mds-button--icon-only__cwp+.mds-button--icon-only__cwp{margin-left:16px}.mds-button-container__cwp .mds-button--icon-only__cwp+.mds-button--icon-only__cwp.mds-button--small__cwp,.mds-button-container__cwp .mds-button--icon-only__cwp+.mds-button__cwp.mds-button--small__cwp{margin-left:12px}.mds-button-container__cwp.mds-button-container--right-aligned__cwp{justify-content:flex-end}", ""]);
// Exports
exports.locals = {
	"mds-button-container": "mds-button-container__cwp",
	"mds-button": "mds-button__cwp",
	"mds-button--small": "mds-button--small__cwp",
	"mds-button--icon-only": "mds-button--icon-only__cwp",
	"mds-button-container--right-aligned": "mds-button-container--right-aligned__cwp"
};
module.exports = exports;
